import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'DEPARTAMENTO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'DEPARTAMENTO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('departamentoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {

		const tryFetch = (retriesLeft) => {
			const usuario = getState().auth.usuarioCarregado;

			if (usuario) {
				axios.get(`${consts.API_URL}/departamento`)
					.then(resp => {
						dispatch({
							type: 'DEPARTAMENTO_LISTADO',
							payload: resp,
							id_perfil: usuario.id_perfil,
							departamentos_usuario: usuario.departamentos || []
						});
					})
					.catch(e => {
						console.log('Erro ao carregar departamentos:', e);
					});
			} else if (retriesLeft > 0) {
				setTimeout(() => tryFetch(retriesLeft - 1), 1000);
			} else {
				console.warn('Usuário não carregado após várias tentativas.');
			}
		};

		tryFetch(5);
	};
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/departamento`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/departamento`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/departamento?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaGrupo() {
    const request = axios.get(`${consts.API_URL}/departamento/listarSelect`);
    return {
        type: 'DEPARTAMENTO_GRUPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCidade() {
    const request = axios.get(`${consts.API_URL}/cidade/listarSelectGeral`);
    return {
        type: 'DEPARTAMENTO_CIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function importar(tabela) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));
		let listaDepartamento = [];
		let listaEndereco = [];

		for (var i = 0; i < tabela.length; i++) {
			let item = tabela[i];

			let departamento = {
				id_petroshow: String(item[2] || '').trim(),
				razao_social: String(item[3] || '').trim().substring(0, 299).trim(),
				nome_fantasia: String(item[4] || '').trim().substring(0, 299).trim(),
				cnpj: String(item[5] || '').trim().length == 14 ? item[5] : null,
				cpf: String(item[5] || '').trim().length == 14 ? null : item[5],
				id_tipo: String(item[5] || '').trim().length == 14 ? 2 : 1,
				inscricao_estadual: item[6],
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			};

			let endereco = {
				id_petroshow: null,
				id_petroshow_departamento: item[2],
				id_departamento: null,
				codigo_vendedor: item[8],
				endereco: String(item[16] || '').trim().substring(0, 299).trim(),
				bairro: '',
				numero: String(item[18] || '').trim().substring(0, 149).trim(),
				id_cidade: null,
				telefone: FormatUtils.removerMascara(String(item[10] || '')).trim().substring(0, 11).trim(),
				celular: FormatUtils.removerMascara(String(item[12] || '')).trim().substring(0, 11).trim(),
				latitude: String(item[19] || '').trim().substring(0, 19).trim(),
				longitude: String(item[20] || '').trim().substring(0, 19).trim(),
				croqui: null,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}

			if (!listaDepartamento.filter(cli => cli.id_petroshow == departamento.id_petroshow).length && departamento.id_petroshow 
					&& departamento.razao_social && departamento.nome_fantasia && (departamento.cpf || departamento.cnpj) && endereco.endereco) {
				listaDepartamento.push(departamento);
			}
			if (endereco.endereco) {
				listaEndereco.push(endereco);		
			}
			
		}

		await axios.post(`${consts.API_URL}/departamento/importar`, {
			lista: listaDepartamento
		}).then(resp => {
		}).catch(e => {
			setErroAPI(e);
		});

		await axios.post(`${consts.API_URL}/endereco/importar`, {
			lista: listaEndereco
		}).then(resp => {
		}).catch(e => {
			setErroAPI(e);
		});

		setSuccess('Importação Realizada com sucesso.');
		dispatch(getLista());
		dispatch(setAguardando(false));
    };
}
